import { Page } from '@customTypes/page';
import Layout from '@layouts/CommonLayout';
import StaticContentContainer from '@modules/static/components/StaticContentContainer';
import StaticContentHeader from '@modules/static/components/StaticContentHeader';
import StaticTerms from '@modules/static/components/StaticTerms';
import s from '@styles/pages/Static.module.scss';

const TermsPage: Page = () => (
  <div className={s.root}>
    <div className="container-small">
      <StaticContentContainer>
        <StaticContentHeader />

        <StaticTerms />
      </StaticContentContainer>
    </div>
  </div>
);

TermsPage.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>;
};

export default TermsPage;
